import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { useStore } from "../../app/stores/store";
import { Formik, Form } from "formik";
import * as Yup from 'yup';
import MyTextInput from "../../app/common/form/MyTextInput";
import { CambiarCorreoyContraseñaFormValues, RecuperarUsuarioFormValues } from "../../app/models/RecuperarUsuario";
import RecuperarPassword from "../../components/Modals/RecuperPass";
import Loginmoodle from "../Menus/Autenticar";
import LoginForm from "../../features/users/LoginForm";
import { AlignCenter } from "react-bootstrap-icons";
import { BsEyeSlash } from "react-icons/bs";
import "./Login&Register.css"

interface Props {
    padre: string;
}

export default observer(function RecuperarUsuario(props: Props) {
    const lowercaseRegex = /(?=.*[a-z])/;
    const uppercaseRegex = /(?=.*[A-Z])/;
    const numericRegex = /(?=.*[1-9])/;
    const caracterRegex = /(?=.*[@$!%*#?&%-/])/;
    const [hayUsuario, sethayUsuario] = useState(false);
    const { PassStore, modalStore, RecuperarUsuarioStore} = useStore();
    const { passRecuperar, loading } = PassStore;
    const [cui] = useState<RecuperarUsuarioFormValues>(new RecuperarUsuarioFormValues());
    const [passwordShown, setPasswordShown] = useState(false);
    const [correoUsuario, setCorreoUsuario] = useState("")
    const [passwordConfirmaShown, setPasswordConfirmaShown] = useState(false);

    const validationSchema = Yup.object({
        cui: Yup.string().required('Obligatorio'),

    })

    const validationSchema1 = Yup.object({
        email: Yup.string().required('Obligatorio'),
        password: Yup.string()
            .min(8, "Se requieren al menos 8 caracteres, entre ellos, al menos una letra mayuscula, un número y un caracter especial")
            .matches(lowercaseRegex,
                "Debe incluir minusculas"
            )
            .matches(uppercaseRegex,
                "Debe incluir alguna mayuscula"
            )
            .matches(numericRegex,
                "Debe incluir algun numero"
            )
            .matches(caracterRegex,
                "Debe incluir algun caracter especial"
            )
            .required("La contraseña es obligatoria"),
            passwordConfirma: Yup.string().required("La confirmación es obligatoria")
            .oneOf([Yup.ref("password")], "Las Contraseñas no coinciden"),
    })

    function handleFormSubmit(cui:RecuperarUsuarioFormValues) {
        //console.log(cui)
        RecuperarUsuarioStore.RecuperarUsuarioDPI(cui).then(() => {
            //console.log(RecuperarUsuarioStore.existeUsuario)
            sethayUsuario(RecuperarUsuarioStore.existeUsuario)
            setCorreoUsuario(RecuperarUsuarioStore.correoUser)
            });

    }

    function handleFormSubmit1(credencialesIngresadas:any) {
        //console.log(credencialesIngresadas.email)
        let newCorreoContraseña:CambiarCorreoyContraseñaFormValues = {
            email: credencialesIngresadas.email,
            token: RecuperarUsuarioStore.idUsuario,
            password: credencialesIngresadas.password
        }
        RecuperarUsuarioStore.CambiarContraseñaCorreo(newCorreoContraseña).then(() => {
            modalStore.openModal(<LoginForm />, ["tiny"])
        });
    }

    if (PassStore.loadingInitial) return <LoadingComponent content='Cargando...' />

    return (

        <div className="modal_pago_cur modal-reset-password">

            <div className="modal_pago_head">
                <h1>Recuperar usuario</h1>
            </div>

            <Formik validationSchema={validationSchema}
                enableReinitialize
                initialValues={cui}
                onSubmit={values => {
                    if(hayUsuario == false){
                        handleFormSubmit(values)
                    }else{
                        if(props.padre == "LoginForm"){
                            modalStore.openModal(<LoginForm />, ["tiny"])
                        }else if(props.padre == "RecuperarContraseña"){
                            modalStore.openModal(<RecuperarPassword correo={correoUsuario} />, ["tiny"])
                        }
                    }
                    }
                    }>
                {({ handleSubmit, isValid, isSubmitting, dirty }) => (

                    <Form onSubmit={handleSubmit} autoComplete='off' className="contenido_modal_pago">

                        <p>Ingresa el DPI</p>

                        <MyTextInput className="reset-input" name='cui' placeholder='0000000000000' type="text" />

                        {hayUsuario ?
                        <>
                            <span style={{color:"#062d16" ,fontSize: "13px", borderBottom:"4px"}}>El correo registrado es:</span>
                            <span style={{fontSize: "20px"}}>{RecuperarUsuarioStore.correoUser}</span>
                            <span style={{color:"#9A0D04" ,fontSize: "13px", marginTop:"10px", textAlign:"center", paddingLeft:"10px", paddingRight:"10px"}}>Recuerda que si ya no posees acceso a este correo, debes comunicarte al 2419-8181 o enviar un correo a registro@inap.gob.gt solicitando acceso.</span>
                        </>
                        :
                        <>
                        </>
                        }

                        <div className="botones_pago_modal">
                            <Button
                                loading={loading}
                                type='submit'
                                content={hayUsuario ? "ok" : "Consultar"}
                                className="primary"
                            />
                        </div>

                    </Form>
                )}
            </Formik>

            {/* {hayUsuario ?
            <>
                <Formik validationSchema={validationSchema1}
                    enableReinitialize
                    initialValues={CambiarCorreoyContraseñaFormValues}
                    onSubmit={values => {
                        handleFormSubmit1(values)}
                        }>
                    {({ handleSubmit, isValid, isSubmitting,errors, dirty }) => (

                        <Form onSubmit={handleSubmit} autoComplete='off' className="contenido_modal_pago">
                            
                            <div className='login-form-content' style={{position:"relative"}}>
                                <MyTextInput name='email' label='Ingresa el correo electrónico' placeholder='tu-correo@gmail.com' />
                                <MyTextInput name='password' label='Ingresa una nueva contraseña' className='password-input' placeholder='********' type={passwordShown ? "text" : "password"} />
                                <div className='showpassword-area'>
                                    <a className='showPassword' style={{top: "90px", position: "absolute", height: "33.5px"}} onClick={() => setPasswordShown(!passwordShown)}> <BsEyeSlash /></a>
                                </div>
                                <div className="CambiarUserPassConfirm">
                                    <MyTextInput name='passwordConfirma' label='confirmar contraseña nueva' placeholder='********' type={passwordConfirmaShown ? "text" : "password"} />
                                    <div className='showpassword-area'>
                                        <a className='showPassword' style={{top: "21px", position: "absolute", height: "33.5px"}}  onClick={() => setPasswordConfirmaShown(!passwordConfirmaShown)}> <BsEyeSlash /></a>
                                    </div>
                                </div>
                            </div>
                            <span style={{color:  "#538cbe", fontSize: "10px", textAlign:"center", paddingLeft:"10px"}}>La contraseña debe al menos contener 8 caracteres; incluyendo mayusculas, minúsculas, números y caracteres especiales.</span>

                            <div className="botones_pago_modal">
                                <Button
                                    loading={loading}
                                    type='submit'
                                    content='Enviar'
                                    className="primary"
                                />
                            </div>

                        </Form>
                    )}
                </Formik>
            </>
            :
            <>
            </>
            } */}

        </div>

    )
})
